// extracted by mini-css-extract-plugin
export default {"container":"Login_container__IwEN2","formLog":"Login_formLog__9hbTy","error":"Login_error__T8USG","header":"Login_header__CT2YS","arrow":"Login_arrow__E14mJ"};